import type { QuickEntry, QuickEntryOption } from '@/services/home/home'

export const QUICK_ENTRY_ROW_COUNT = 4

export class QuickEntryValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'QuickEntryValidationError'
  }
}

function normalized(value?: string) {
  return value?.trim() || ''
}

export function resolveQuickEntryTarget(path?: string) {
  const target = normalized(path)
  return target === '/patient/add' ? '/patient?action=add' : target
}

export function createQuickEntryDraft(entries: QuickEntry[], rowCount = QUICK_ENTRY_ROW_COUNT) {
  const draft = entries.map((entry) => ({ ...entry }))
  while (draft.length < rowCount) draft.push({ item: '', url: '', icon: '', status: '' })
  return draft
}

export function getQuickEntryName(entry: QuickEntry, projects: QuickEntryOption[]) {
  const value = normalized(entry.item) || normalized(entry.url)
  return projects.find((option) => option.value === value)?.label || entry.name || '未命名入口'
}

export function buildQuickEntryPayload(entries: QuickEntry[], projects: QuickEntryOption[]) {
  const usedItems = new Set<string>()

  return entries.map((entry) => {
    const item = normalized(entry.item)
    const icon = normalized(entry.icon)
    const status = normalized(entry.status)
    const isEmpty = !item && !icon && !status

    if (isEmpty) return { ...entry, item: '', url: '', icon: '', status: '', name: '' }
    if (!item || !icon || !status) throw new QuickEntryValidationError('请将信息选择完整')
    if (usedItems.has(item)) throw new QuickEntryValidationError('请勿添加重复快捷菜单！')
    usedItems.add(item)

    return {
      ...entry,
      item,
      url: item,
      icon,
      status,
      name: projects.find((option) => option.value === item)?.label || entry.name || ''
    }
  })
}
